import { AfterViewInit, Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { environment } from '@biletix/env';
import { LocaleSelectorComponent } from '@biletix/core/common/locale-selector.component';
import { TranslateService } from '@ngx-translate/core';
import { I18nService } from '@biletix/core/services/i18n.service';
import { ActivatedRoute } from '@angular/router';
import { RegionService } from '@biletix/core/services/region.service';
import { RouteParameter } from '@biletix/core/common/constants/route-parameter.const';
import { EventDetail } from '@biletix/core/models/event/event-detail.model';
import { EventPageStateService } from '@biletix/features/event/services/event-page-state.service';
import { WINDOW } from '@biletix/core/common';
// import { GoogleTagManagerService } from 'angular-google-tag-manager';
import { Title } from '@angular/platform-browser';
import { Clipboard } from '@angular/cdk/clipboard';
import { ShareButtonsConfig } from '@biletix/shared/components/share-button/share-button.component';
import { ImageUrlManager } from '@biletix/core/common/helper/image-url-manager';
import { ImageProcessing } from '@biletix/core/common/utils/image-processing';
import { RouterService } from '@biletix/core/services/router.service';
import { Locale, Region } from '@biletix/core/common';
import { LocalizedDatePipe } from '@biletix/shared/pipes/localized-date.pipe';
import { ApiService } from '@biletix/core/services/api.service';
import { DeviceDetectorService } from 'ngx-device-detector';
import { APP_BASE_HREF, isPlatformBrowser } from '@angular/common';
import { SeoService } from '@biletix/core/services/seo.service';
import { Platform } from '@angular/cdk/platform';
import { CanonicalService } from '@biletix/core/services/canonical.service';
import { SeoPagePath, SeoUrlService } from '@biletix/core/services/seo-url.service';
import { EventService } from '@biletix/core/services/event.service';
import { BtxPerformanceListItem } from '@biletix/core/models/event/performance-list-item.model';
import { FacebookPixelService } from '@biletix/core/services/facebook-pixel.service';
import { GPT_AD_SLOT_IDS, GptAdService } from '@biletix/core/services/gpt-ad.service';
import { GtmService } from '@biletix/core/services/gtm.service';
import { FancyboxLoaderService } from '@biletix/core/services/fancybox-loader.service';
import {
  GA4_CURRENCY,
  buildGa4EventItem,
  resolveListItemPrice,
} from '@biletix/core/common/utils/ga4-ecommerce.util';
import { StructuredDataService } from '@biletix/core/services/structured-data.service';
import {
  SCHEMA_DATE_FORMAT,
  pruneEmpty,
  schemaEventType,
  toPlainText,
} from '@biletix/core/common/utils/structured-data.util';

@Component({
  standalone: false,
  selector: 'btx-event',
  templateUrl: './event.component.html',
  styleUrls: ['./event.component.scss'],
})
export class EventComponent extends LocaleSelectorComponent implements OnInit, AfterViewInit {
  eventCode: string = '';
  eventDetail: EventDetail;
  eventImage: string | any;
  wideImage: string | any;
  eventImageSrc!: string;
  eventSmallImageSrc!: string;
  eventMidImageSrc!: string;
  eventNoSrc!: string;
  photoItems: string[] = [];
  environment = environment;
  config!: ShareButtonsConfig;
  color: string = '#00000';

  langParam!: string;
  regionParam!: string;

  adsImageTr = '';
  adsImageEn = '';

  editedEndDate!: Date;

  locales!: Locale[];
  currentLocale!: Locale;

  regions!: Region[];
  currentRegion!: Region;
  currentLang!: string;
  mobileGallery: string[] = [];

  cDefinitionQueryParam: string = '';
  cQueryParam: string = '';
  deviceInfo: string = '';

  breadcrumbItems: any;

  eventFavorites: { type: string; code: string; time: Date }[] = [];
  private eventStorageKey = 'eventFavorites';

  performanceList: BtxPerformanceListItem[] = [];

  /**
   * Etkinliğin süresi geçtiyse `true`. Bu durumda satın alma akışı yerine
   * "etkinlik sona erdi" görünümü gösterilir; sunucu aynı URL'de 410 döner
   * (bkz. EventDetailResolver.markPastEvent).
   */
  isEventEnded: boolean = false;

  isFlexibleEventTime = false;

  flexibleTimeWarningMessage: string = '';
  dayMonthSection!: string;
  hourSection!: string;

  /** JSON-LD `<script>` etiketinin `id`'si; blok bu id ile idempotent güncellenir. */
  private static readonly SCHEMA_ELEMENT_ID = 'btx-event-schema';

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    @Inject(WINDOW) private window: Window,
    @Inject(APP_BASE_HREF) private baseHref: string,
    private translateService: TranslateService,
    private clipboard: Clipboard,
    private activatedRoute: ActivatedRoute,
    private titleService: Title,
    private eventPageStateService: EventPageStateService,
    private routerService: RouterService,
    public region: RegionService,
    public i18n: I18nService,
    protected localizedDatePipe: LocalizedDatePipe,
    private canonicalService: CanonicalService,
    private seoUrlService: SeoUrlService,
    private apiService: ApiService,
    private seo: SeoService,
    private eventService: EventService,
    private translate: TranslateService,
    private platform: Platform,
    private facebookPixelService: FacebookPixelService,
    private gptAdService: GptAdService,
    private gtmService: GtmService,
    private structuredDataService: StructuredDataService,

    private deviceSelectorService: DeviceDetectorService,
    private fancyboxLoader: FancyboxLoaderService,
  ) {
    super(translateService, i18n);
    this.eventDetail = this.eventPageStateService.getCurrentEventDetail();
    this.isEventEnded = this.eventPageStateService.isCurrentEventEnded();
    if (this.eventDetail) {
      this.eventImage = this.getEventImage();
      this.eventImageSrc = this.getEventImage();
      this.eventSmallImageSrc = this.getSmallEventImage();
      this.eventMidImageSrc = this.getMidEventImage();
      this.eventNoSrc = this.getNoImage();
      this.wideImage = this.getWideImage();
      this.photoItems = this.getEventImages();
      this.langParam = this.activatedRoute.snapshot.params[RouteParameter.PARAMS.LANGUAGE];
      this.regionParam = this.activatedRoute.snapshot.params[RouteParameter.PARAMS.REGION];
      this.mobileGallery.push(this.eventImageSrc, ...this.photoItems);
      this.editedEndDate = new Date();
      this.performanceList = this.eventPageStateService.getCurrentPerformanceList();
      this.eventCode = this.activatedRoute.snapshot.params[RouteParameter.PARAMS.EVENT_CODE];
      this.cQueryParam = this.activatedRoute.snapshot.queryParams['c'];
      this.cDefinitionQueryParam = this.activatedRoute.snapshot.queryParams['definitionCode'];
      this.locales = this.i18n.getAvailableLocales();
      this.currentLocale = this.i18n.currentLocale;
      this.regions = this.region.getRegions();
      this.currentRegion = this.region.currentRegion;
      this.currentLang = this.currentLocale.lang;
      if (isPlatformBrowser(this.platformId) && deviceSelectorService.isDesktop()) {
        this.deviceInfo = 'desktop';
      } else {
        this.deviceInfo = 'mobile';
      }
    }
  }

  ngOnInit() {
    this.loadFavorites();

    this.getAdsImageLink();
    this.addFacebookPixelData();
    this.facebookPixelService.checkAndInject(this.eventDetail?.promoterCode);
    this.pushViewItem();
    this.initializeVariables();
    this.translateService
      .stream([
        'shared.labels.titleTickets',
        'shared.labels.officialSite',
        'shared.labels.siteKeywords',
        'sales.labels.events',
      ])
      .pipe(this.takeUntilDestroy())
      .subscribe((translations) => {
        this.titleService.setTitle(
          (this.eventDetail?.eventName ?? '') +
          (translations['shared.labels.titleTickets'] ?? ''),
        );
        this.initSeo(translations);
        this.addSchema();
        this.updateBreadcrumbItems(translations);
      });
  }

  updateBreadcrumbItems(translations: Record<string, string>) {
    this.breadcrumbItems = [];
    this.breadcrumbItems.push({
      label: this.eventDetail.eventCategory,
      href: this.routerService.createCategoryPageUrl(this.eventDetail?.eventCategoryCode),
    });
    this.breadcrumbItems.push({
      label: this.eventDetail?.subCategory,
      href: this.routerService.createSearchPageUrl(this.eventDetail?.subCategoryCode),
    });
    if (this.eventDetail.eventGroupId) {
      if (this.eventDetail.eventGroupCustomUrl) {
        this.breadcrumbItems.push({
          label: this.eventDetail?.eventGroupName,
          href: this.eventDetail.eventGroupCustomUrl,
        });
      } else {
        const eventsLabel = translations['sales.labels.events'] || 'Etkinlikleri';
        this.breadcrumbItems.push({
          label: this.eventDetail?.eventGroupName + ' ' + eventsLabel,
          href:
            this.routerService.createEventGroupPageUrl(this.eventDetail.eventGroupId) +
            '/' +
            this.eventDetail.eventGroupKeyUrlText,
        });
      }
    }
    this.breadcrumbItems.push({
      label: this.eventDetail?.eventName,
      href: this.routerService.createEventPageUrl(this.eventDetail?.eventCode, this.eventDetail?.eventKeyUrlText),
    });

    if (
      this.eventDetail?.flexibleTimeEventCheck &&
      this.eventDetail?.startShowDate &&
      this.eventDetail?.endShowDate
    ) {
      this.isFlexibleEventTime = true;

      const start = this.eventDetail.startShowDate;
      const end = this.eventDetail.endShowDate;

      const dayMonthFormat = 'dd.MM.yyyy';
      const hourSeparator = this.translate.currentLang === 'tr' ? ' ile ' : ' to ';
      const timeFormat = 'HH:mm';

      this.dayMonthSection =
        this.localizedDatePipe.transform(start, dayMonthFormat) +
        ' - ' +
        this.localizedDatePipe.transform(end, dayMonthFormat);

      this.hourSection =
        this.localizedDatePipe.transform(start, timeFormat) +
        hourSeparator +
        this.localizedDatePipe.transform(end, timeFormat);

      this.flexibleTimeWarningMessage = this.translate.instant(
        'shared.labels.flexibleTimeWarningMessage',
        {
          dayMonthSection: this.dayMonthSection,
          hourSection: this.hourSection,
        },
      );
    } else {
      this.isFlexibleEventTime = false;
    }
  }

  ngAfterViewInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      // Yan sütundaki 300x600 slot şablonda koşulsuz olduğu için burada
      // gösterime açılabiliyor; mobilde alan CSS ile gizliyse servis
      // görünürlük kontrolünde isteği atlıyor.
      this.gptAdService.displayAndRefreshAds([GPT_AD_SLOT_IDS.SIDE_BANNER_300X600]);
      if (this.photoItems.length > 0) {
        this.fancyboxLoader.loadWhenIdle();
      }
    }
  }

  isAvifImage(src?: string | null): boolean {
    if (!src) {
      return false;
    }
    return src.toLowerCase().endsWith('.avif');
  }

  /**
   * Etkinliğin JSON-LD bloğunu yazar.
   *
   * `ngOnInit`'ten (SEO etiketleriyle aynı yerde) çağrılır ve platform guard'ı
   * yoktur: `StructuredDataService` `DOCUMENT` üzerinden yazdığı için blok SSR
   * HTML'inde de yer alır. Önceden `ngAfterViewInit` + `isPlatformBrowser`
   * içindeydi, yani yapısal veri yalnız tarayıcıda oluşuyordu.
   */
  private addSchema(): void {
    this.structuredDataService.setJsonLd(
      EventComponent.SCHEMA_ELEMENT_ID,
      this.createEventSchema(),
    );
  }

  private getEventImages(): string[] {
    const images = this.eventDetail.images ?? [];
    return images.map((url: string) =>
      ImageUrlManager.create(url, environment.eventPhotosBasePath),
    );
  }

  /**
   * Sayfanın kanonik yol parçaları.
   *
   * Slug BİLİNÇLİ olarak dahil edilir: `/etkinlik/KOD/.../slug` ve slug'sız hâli
   * ikisi de 200 dönüyor, kanonik olan slug'lı sürümdür — event-group sayfası da
   * (`event-group.component.ts`) aynı kuralı uyguluyor.
   */
  private get seoPagePath(): SeoPagePath {
    return {
      segments: ['etkinlik', this.eventDetail?.eventCode ?? ''],
      slug: this.eventDetail?.eventKeyUrlText,
    };
  }

  initSeo(translations: Record<string, string>) {
    const pagePath = this.seoPagePath;
    const canonicalUrl = this.seoUrlService.buildCanonicalUrl(pagePath, this.langParam);

    this.seo.setTags({
      title:
        this.eventDetail?.eventName +
        (translations['shared.labels.titleTickets'] ?? '') +
        (translations['shared.labels.officialSite'] ?? '') +
        ' | ' +
        this.localizedDatePipe.transform(this.eventDetail?.firstPerformanceDate, 'yyyy-MM-dd') +
        ' | ' +
        this.eventDetail?.venueCity,
      titleSuffix: '',
      description: this.eventDetail?.eventDescription,
      image: ImageUrlManager.toSocialShareImage(this.eventImageSrc),
      imageAlt: this.eventDetail?.eventName,
      keywords:
        this.eventDetail?.eventName + (translations['shared.labels.siteKeywords'] ?? ''),
      // og:url canonical ile aynı olmalı; document.URL SSR'da http üretiyordu.
      url: canonicalUrl,
    });
    this.canonicalService.setCanonicalUrl(canonicalUrl);
    this.canonicalService.setAlternateUrls(this.seoUrlService.buildAlternateUrls(pagePath));
  }

  // onSmallImageError(event: Event) {
  //   const img = event.target as HTMLImageElement;
  //   img.src = this.eventImageSrc;  // fallback
  // }

  // onSmallImageError(event: Event) {
  //   const img = event.target as HTMLImageElement;

  //   // 1) Daha önce fallback denemesi yapılmış mı?
  //   if (img.dataset.fallbackApplied === 'true') {
  //     // fallback de yok → son çare: placeholder
  //     img.src = this.getNoImage();
  //     return;
  //   }

  //   // 2) fallback dene
  //   img.dataset.fallbackApplied = 'true';
  //   img.src = this.eventImageSrc;
  // }

  onImgError(event: Event) {
    const img = event.target as HTMLImageElement;

    // Eğer fallback zaten uygulanmışsa tekrar denemeye gerek yok → çık
    if (img.dataset['fallback'] === 'true') {
      return;
    }

    // 1) Picture içindeki tüm source'ları temizle (bildiğin responsive kırma)
    const picture = img.closest('picture');
    if (picture) {
      picture.querySelectorAll('source').forEach((source) => {
        source.setAttribute('srcset', '');
      });
    }

    // 2) Fallback görseli 1 kez ata
    img.src = 'this.eventImageSrc';

    // 3) Bir daha error tetiklenirse girmesin → işaret bırak
    img.dataset['fallback'] = 'true';
  }

  /**
   * Etkinlik sayfasının schema.org `Event` nesnesi.
   *
   * Önceki sürüm `performanceList` üzerinde döngü kurup her performans için bir
   * nesne üretiyordu; ancak nesnenin performansa özel tek alanı `name`'di ve o da
   * tüm performanslarda aynı değeri taşıyor (`eventName`) — yani N adet BİREBİR
   * AYNI varlık yayınlanıyordu. Bu sayfa tek bir etkinliği temsil ediyor, tek
   * nesne yayınlanır; performansların kendi sayfaları var (`/performance/...`).
   *
   * Fiyat `performanceList`'teki en düşük değerden türetilir; `offers` fiyat
   * taşımadığında Google zengin sonuç uyarısı veriyor.
   */
  private createEventSchema(): Record<string, unknown> | null {
    // Süresi geçmiş etkinlikte sayfa 410 dönüyor ve satın alma akışı kapalı;
    // böyle bir sayfada satılabilir bir etkinlik ilan etmek yanlış sinyal.
    if (!this.eventDetail?.eventCode || this.isEventEnded) {
      return null;
    }

    const canonicalUrl = this.seoUrlService.buildCanonicalUrl(this.seoPagePath, this.langParam);
    const lowestPrice = this.getLowestPerformancePrice();

    return pruneEmpty<Record<string, unknown>>({
      '@context': 'https://schema.org',
      '@type': schemaEventType(this.eventDetail.eventCategoryCode),
      url: canonicalUrl,
      // Servisten gelen adlarda sondaki `\r\n` olabiliyor (ör. 5EF8F).
      name: this.eventDetail.eventName?.trim(),
      // Açıklama editörden HTML geliyor; JSON-LD düz metin ister.
      description: toPlainText(this.eventDetail.eventDescription),
      image: ImageUrlManager.toSocialShareImage(this.eventImageSrc),
      // `startShowDate`/`endShowDate` YALNIZ esnek zamanlı etkinliklerde dolu
      // (canlı yanıtta çoğu etkinlikte null) — eski JSON-LD bu yüzden startDate
      // alanını hiç yayınlamıyordu, oysa Google zengin sonuç için zorunlu tutuyor.
      // Sabit tarihli etkinliklerde performans aralığına düşülür.
      startDate: this.localizedDatePipe.transform(
        this.eventDetail.startShowDate ?? this.eventDetail.firstPerformanceDate,
        SCHEMA_DATE_FORMAT,
      ),
      endDate: this.localizedDatePipe.transform(
        this.eventDetail.endShowDate ?? this.eventDetail.lastPerformanceDate,
        SCHEMA_DATE_FORMAT,
      ),
      eventStatus: 'https://schema.org/EventScheduled',
      eventAttendanceMode: 'https://schema.org/OfflineEventAttendanceMode',
      location: {
        '@type': 'Place',
        name: this.eventDetail.venueName,
        address: {
          '@type': 'PostalAddress',
          streetAddress: this.eventDetail.venueTown,
          addressLocality: this.eventDetail.venueCity,
          // schema.org ISO 3166 kodu ister; `venueCountry` görünen ad ("Türkiye").
          addressCountry: 'TR',
        },
        // Koordinat yoksa `pruneEmpty` `@type` yüzünden nesneyi atmıyor ve geçersiz
        // bir `{"@type":"GeoCoordinates"}` kalıyordu; tek koordinat da geçersiz.
        geo:
          this.eventDetail.venueLatitude && this.eventDetail.venueLongitude
            ? {
                '@type': 'GeoCoordinates',
                latitude: this.eventDetail.venueLatitude,
                longitude: this.eventDetail.venueLongitude,
              }
            : undefined,
      },
      performer: this.eventDetail.artistDetails?.[0]?.artistName
        ? {
          '@type': 'PerformingGroup',
          name: this.eventDetail.artistDetails[0]?.artistName,
        }
        : undefined,
      organizer: this.eventDetail.promoterName
        ? { '@type': 'Organization', name: this.eventDetail.promoterName }
        : undefined,
      offers: {
        '@type': 'Offer',
        availability: 'https://schema.org/LimitedAvailability',
        url: canonicalUrl,
        price: lowestPrice,
        priceCurrency: lowestPrice === undefined ? undefined : GA4_CURRENCY,
        validFrom: this.localizedDatePipe.transform(
          this.eventDetail.publishDate,
          SCHEMA_DATE_FORMAT,
        ),
      },
    });
  }


  addFacebookPixelData() {
    (this.window as any)['digitalData'] = [
      {
        page: {
          pageInfo: {
            campaign: this.cQueryParam,
            destinationURL: this.window.location.href,
            domain: this.apiService.getDomain(),
            geoRegion: this.currentRegion.name,
            language: this.currentLocale.lang,
            pageChannel: 'EDP',
            pageName: 'EDP: Classic: Event',
            pageType: 'EDP: Classic: Event',
            referringURL: '',
            sysEnv: this.deviceInfo,
          },
          attributes: {
            artistName: this.eventDetail?.eventName,
            city: this.eventDetail?.venueCity,
            country: this.eventDetail?.venueCountry,
            eventDate: this.localizedDatePipe.transform(
              this.eventDetail?.firstPerformanceDate,
              'yyyy-MM-dd HH:mm:ss',
            ),
            eventDateEnd: this.localizedDatePipe.transform(
              this.eventDetail?.lastPerformanceDate,
              'yyyy-MM-dd HH:mm:ss',
            ),
            eventDateStart: this.localizedDatePipe.transform(
              this.eventDetail?.firstPerformanceDate,
              'yyyy-MM-dd HH:mm:ss',
            ),
            eventID: this.eventDetail?.eventCode,
            eventName: this.eventDetail?.eventName,
            eventTime: this.localizedDatePipe.transform(
              this.eventDetail?.firstPerformanceDate,
              'HH:mm',
            ),
            promoterId: this.eventDetail?.promoterCode,
            venueId: this.eventDetail?.venueId,
            venueName: this.eventDetail?.venueName,
          },
          category: {
            organization: 'TM_Turkey',
            primaryCategory: this.eventDetail?.eventCategory,
            primaryCategoryID: '',
            subCategory1: this.eventDetail?.subCategory,
            subCategory1Id: '',
          },
        },
      },
    ];
  }

  /**
   * GA4 `view_item` event'ini gönderir.
   *
   * Veri constructor'da `EventPageStateService`'ten hazır geldiği için ek istek
   * yok; `ngOnInit`'te tek kez çağrılır (`FacebookPixelService.checkAndInject`
   * ile aynı kalıp). Platform guard'ı `GtmService.push` içinde: her rota
   * `RenderMode.Server` olduğundan bileşenden doğrudan `dataLayer`'a yazmak
   * SSR'da patlıyor.
   *
   * Fiyat, performans listesindeki en düşük `minPrice`'tan türetilir; liste
   * boşsa `EventDetail.price` metnine düşülür. Etkinlik sayfası birden çok
   * performansı kapsadığı için `item_id`'de tarih yalnız tek performans varsa
   * anlamlı olurdu → ilk performans tarihi kullanılmaz, `eventCode` yeterlidir.
   */
  private pushViewItem(): void {
    if (!this.eventDetail) {
      return;
    }

    const item = buildGa4EventItem({
      eventCode: this.eventDetail.eventCode,
      eventName: this.eventDetail.eventName,
      price: this.getLowestPerformancePrice() ?? this.eventDetail.price,
      category: this.eventDetail.eventCategory,
      subCategoryCode: this.eventDetail.subCategoryCode,
      venueName: this.eventDetail.venueName,
      brand: this.eventDetail.artistDetails?.[0]?.artistName ?? this.eventDetail.promoterName,
    });

    this.gtmService.pushEcommerce('view_item', {
      currency: GA4_CURRENCY,
      value: item.price ?? 0,
      items: [item],
    });
  }

  /**
   * Performans listesindeki en düşük fiyat (TL); hiçbiri çözülemezse undefined.
   *
   * `resolveListItemPrice` kullanılır: `minPrice` kuruş cinsinden sayı,
   * `priceInfo` biçimlenmiş metin — ikisi aynı ayrıştırıcıya verilemez.
   */
  private getLowestPerformancePrice(): number | undefined {
    const prices = (this.performanceList ?? [])
      .map((performance) => resolveListItemPrice(performance.minPrice, performance.priceInfo))
      .filter((price): price is number => price !== undefined);

    return prices.length ? Math.min(...prices) : undefined;
  }

  initializeVariables() {
    this.config = {
      url: this.window.location.href,
      description: this.eventDetail.eventName,
      title: this.eventDetail.eventName,
      image: this.getEventImage(),
    };
  }

  getEventImage(): string {
    return ImageUrlManager.createEventImage(this.eventDetail.image);
  }

  getNoImage(): string {
    return ImageUrlManager.createEventImage('noimage.gif');
  }

  getSmallEventImage(): string {
    return ImageUrlManager.createSmallEventImage(this.eventDetail.image);
  }

  getMidEventImage(): string {
    return ImageUrlManager.createMidEventImage(this.eventDetail.image);
  }

  getWideImage(): string {
    return ImageUrlManager.createEventWideImage(this.eventDetail.wideImage);
  }

  onLoadImage(imageRef: HTMLImageElement) {
    if (imageRef) {
      const a = ImageProcessing.getAverageRGB(imageRef);
      this.color = a.hex();
    }
  }

  getVenuePageUrl(): string {
    return this.routerService.createVenuePageUrl(this.eventDetail?.venueId, this.eventDetail?.venueKeyUrlText);
  }

  getAdsImageLink() {
    this.adsImageTr = ImageUrlManager.createStaticImage('right-col-image-2024.png');
    this.adsImageEn = ImageUrlManager.createStaticImage('right-col-image-2024-en.png');
  }

  isPhotoGalleryVisible(): boolean {
    return this.photoItems.length > 0;
  }

  IsFavorites(code: string): boolean {
    return this.eventFavorites.some((e) => e.code === code);
  }

  loadFavorites() {
    if (!isPlatformBrowser(this.platformId)) {
      this.eventFavorites = [];
      return;
    }
    const storageFavorites = JSON.parse(localStorage.getItem(this.eventStorageKey) || '[]');
    this.eventFavorites = storageFavorites.map((event: any) => ({
      ...event,
      time: new Date(event.time),
    }));
  }

  toggleFavorites() {
    this.loadFavorites(); // Fetch latest from localStorage to prevent overwriting other tabs

    if (this.IsFavorites(this.eventCode)) {
      this.eventFavorites = this.eventFavorites.filter((e) => e.code !== this.eventCode);
    } else {
      this.eventFavorites.push({
        type: 'event',
        code: this.eventCode,
        time: this.eventDetail.firstPerformanceDate,
      });
    }

    if (isPlatformBrowser(this.platformId)) {
      localStorage.setItem(this.eventStorageKey, JSON.stringify(this.eventFavorites));
    }
  }

  get artistDetails() {
    return this.eventDetail?.artistDetails || [];
  }

  /**
   * "Etkinlik sona erdi" görünümünde önerilecek sanatçılar. Sanatçı sayfası
   * yayında olmayan (`showEventPage` false) kayıtlar bağlantı verilemez.
   */
  get endedEventArtists() {
    return this.artistDetails.filter((artist) => artist.showEventPage && !!artist.artistId);
  }

  getCategoryPageUrl(): string {
    return this.routerService.createCategoryPageUrl(this.eventDetail?.eventCategoryCode);
  }

  get hasArtists(): boolean {
    return this.artistDetails?.some((artist) => artist.showEventPage) ?? false;
  }

  getArtistProfilePhoto(photoUrl: string): string {
    return ImageUrlManager.createArtistProfilePhotoImage(photoUrl);
  }
}
